export default (lowerLimit, upperLimit) => {
  return Math.floor(Math.random() * upperLimit) + lowerLimit;
};
